export default __webpack_public_path__ + "static/media/logo-new-landing.b6b3dc2c.svg";